export const HowyouHeardJson = [
  {
    val: "Website",
  },
  {
    val: "Facebook",
  },
  {
    val: "Instagram",
  },
  {
    val: "Friends",
  },
  {
    val: "SMS",
  },
  {
    val: "Email",
  },
  {
    val: "Other",
  },
];
// var activityHtml = `<div >
//         <div
//          style="
//              background: #fff;
//              color: #000;
//              border-radius: 5px;
//              box-shadow: 0 0 10px rgba(0,0,0,0.2);
//            ">
//            <h2 style="
//                padding: 10px 20px;
//                background-color: #211762;
//                color: #fff;
//                text-align: center;
//              ">
//              Student Information
//            </h2>

//            <div>
//        <div style={ marginTop: "20px" }>
//              <h4 style="${sectionStyle}">Personal Details</h4>
//              <table style="${tableStyle}">
//                <tbody>
//                  <tr>
//                    <td style="${thTdStyle2}">
//                      Branch: <span style="${clr}"> $$Branch</span>
//                    </td>
//                    <td style="${thTdStyle2}">
//                      Event: <span style="${clr}">${eventId || ""} </span>
//                    </td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle2}">
//                      Phone: <span style="${clr}">${
//       details.Phone_No || ""
//     } </span>
//                    </td>
//                    <td style="${thTdStyle2}">

//                      Email Address:<span style="${clr}">${
//       details.Email_Address || ""
//     } </span>
//                    </td>
//                  </tr>

//                  <tr>
//                    <td style="${thTdStyle2}">

//                      First Name:<span style="${clr}"> ${
//       details.First_Name || ""
//     }</span>
//                    </td>
//                    <td style="${thTdStyle2}">
//                      Last Name: <span style="${clr}">${
//       details.Last_Name || ""
//     } </span>
//                    </td>
//                  </tr>

//                  <tr>
//                    <td style="${thTdStyle2}">
//                      Phone No:<span style="${clr}">${
//       details?.Gender.toString() == "1"
//         ? "Male"
//         : details?.Gender.toString() == "2"
//         ? "Female"
//         : "Other" || ""
//     } </span>
//                    </td>
//                    <td style="${thTdStyle2}">

//                      Date of Birth: <span style="${clr}"> ${
//       details.Date_Of_Birth || ""
//     }</span>
//                    </td>
//                  </tr>

//                  <tr>
//                    <td style="${thTdStyle2}">
//                      Marital Status:
//                      <span style="${clr}"> ${
//       details.Marital_Status === "1"
//         ? "Unmarried"
//         : details.Marital_Status === "2"
//         ? "Married"
//         : "Other" || ""
//     }</span>
//                    </td>
//                    <td style="${thTdStyle2}">
//                      Alternate Phone:
//                      <span style="${clr}"> ${details.Phone_No1 || ""}</span>
//                    </td>
//                  </tr>

//                  <tr>
//                    <td style="${thTdStyle2}">
//                      City:<span style="${clr}"> ${details.City || ""}</span>
//                    </td>
//                    <td style="${thTdStyle2}">
//                      State:<span style="${clr}"> ${details.State || ""}</span>
//                    </td>
//                  </tr>
//                </tbody>
//              </table>
//            </div>

//            <div >
//              <h4 style="${sectionStyle}">12th Details</h4>
//              <table style="${tableStyle}"}>
//                <tbody>
//                  <tr>
//                    <td style="${thTdStyle1}">Board:</td>
//                    <td style="${thTdStyle}">${activity.board || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Passing Year:</td>
//                    <td style="${thTdStyle}">${activity.passingYear12 || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Stream:</td>
//                    <td style="${thTdStyle}">${activity.stream || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Percentage:</td>
//                    <td style="${thTdStyle}">${activity.percentage12 || ""}</td>
//                  </tr>
//                </tbody>
//              </table>
//            </div>

//            <div>
//              <h4 style="${sectionStyle}">Bachelor's Details</h4>
//              <table style="${tableStyle}"}>
//                <tbody>
//                  <tr>
//                    <td style="${thTdStyle1}">University:</td>
//                    <td style="${thTdStyle}">${activity.universityUG || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Passing Year:</td>
//                    <td style="${thTdStyle}">${activity.passingYearUG || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Subject:</td>
//                    <td style="${thTdStyle}">${activity.subjectUG || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Percentage:</td>
//                    <td style="${thTdStyle}">${activity.percentageUG || ""}</td>
//                  </tr>
//                </tbody>
//              </table>
//            </div>

//            <div>
//              <h4 style="${sectionStyle}">Master's Details</h4>
//              <table style="${tableStyle}"}>
//                <tbody>
//                  <tr>
//                    <td style="${thTdStyle1}">University:</td>
//                    <td style="${thTdStyle}">${activity.universityPG || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Passing Year:</td>
//                    <td style="${thTdStyle}">${activity.passingYearPG || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Subject:</td>
//                    <td style="${thTdStyle}">${activity.subjectPG || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Percentage:</td>
//                    <td style="${thTdStyle}">${activity.percentagePG || ""}</td>
//                  </tr>
//                </tbody>
//              </table>
//            </div>

//            <div>
//              <h4 style="${sectionStyle}">Preferences</h4>
//              <table style="${tableStyle}"}>
//                <tbody>
//                  <tr>
//                    <td style="${thTdStyle1}">Preferred Degree:</td>
//                    <td style="${thTdStyle}">${
//       activity.preferredDegree || ""
//     }</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Preferred Country:</td>
//                    <td style="${thTdStyle}">${
//       Country?.length ? Country?.join(",") : ""
//     }</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Preferred Field of Study:</td>
//                    <td style="${thTdStyle}">${
//       activity.preferredField || ""
//     }</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Preferred Intake:</td>
//                    <td style="${thTdStyle}">${
//       activity.preferredIntake || ""
//     }</td>
//                  </tr>
//                </tbody>
//              </table>
//            </div>

//            <div>
//              <h4 style="${sectionStyle}">Additional Information</h4>
//              <table style="${tableStyle}"}>
//                <tbody>
//                  <tr>
//                    <td style="${thTdStyle1}">Work Experience:</td>
//                    <td style="${thTdStyle}">${
//       activity.workExperience || ""
//     }</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Given Test:</td>
//                    <td style="${thTdStyle}">${activity.givenTest || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Test Name:</td>
//                    <td style="${thTdStyle}">${activity.testName || ""}</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Heard From:</td>
//                    <td style="${thTdStyle}">${
//       heardFrom?.length ? heardFrom?.join(",") : ""
//     }</td>
//                  </tr>
//                  <tr>
//                    <td style="${thTdStyle1}">Other Comments:</td>
//                    <td style="${thTdStyle}">${activity.otherComments || ""}</td>
//                  </tr>
//                </tbody>
//              </table>
//            </div>
//          </div>
//    </div>`;
